import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import useProfileState from '@/state/profile/profileState';
import EmptySection from '@/views/profile/components/EmptySection.vue';
import useUser from '@/mixins/useUser';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileSkillsView',
  setup(__props) {

const { profile, user, isSelf } = useProfileState();
const { tUserFallback: t } = useUser(user.value);

const hasSkills = computed(() => !!profile.value?.skills?.skillList?.length);
const name = computed(() => user.value?.firstname ?? '');

return { __sfc: true,profile, user, isSelf, t, hasSkills, name, EmptySection }
}

})